import { RBPayrollStatus } from "../types/rbPayrollOwner.types";

export const normalizeDigits = (value: string = "") => String(value || "").replace(/\D/g, "");

export const maskAccountNumber = (value: string = "") => {
  const digits = normalizeDigits(value);

  if (!digits) {
    return "";
  }

  const lastFourDigits = digits.slice(-4);
  const hiddenCount = Math.max(4, digits.length - 4);
  return `${"*".repeat(hiddenCount)}${lastFourDigits}`;
};

// Fixed-length mask for list/selection contexts: shows only the last 4 digits
// and does NOT reveal the account length. e.g. "••••7890".
export const maskAccountLast4 = (value: string = "") => {
  const digits = normalizeDigits(value);

  if (!digits) {
    return "";
  }

  return `••••${digits.slice(-4)}`;
};

export const isImageDocument = (mimeType: string = "") => mimeType.startsWith("image/");

export const getRBPayrollStatusLabel = (status: string) => {
  switch (String(status || "").toUpperCase()) {
    case RBPayrollStatus.PENDING_REVIEW:
      return "Pending Review";
    case RBPayrollStatus.ACTIVE:
      return "Active";
    case RBPayrollStatus.ON_HOLD:
      return "On Hold";
    case RBPayrollStatus.REJECTED:
      return "Requires Attention";
    default:
      return "Not Started";
  }
};

export const getRBPayrollStatusTone = (status: string) => {
  switch (String(status || "").toUpperCase()) {
    case RBPayrollStatus.ACTIVE:
      return "success" as const;
    case RBPayrollStatus.ON_HOLD:
      return "danger" as const;
    case RBPayrollStatus.REJECTED:
      return "danger" as const;
    case RBPayrollStatus.PENDING_REVIEW:
      return "warning" as const;
    default:
      return "default" as const;
  }
};
